import { render, staticRenderFns } from "./deleteItem.vue?vue&type=template&id=8b0584c0&scoped=true&"
import script from "./deleteItem.vue?vue&type=script&lang=js&"
export * from "./deleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0584c0",
  null
  
)

export default component.exports